import {match, Pattern} from 'ts-pattern';

import {getWorktreeName} from '@dms/config';

import {WORKTREE_HEADER} from '../constants/WORKTREE_HEADER';

/**
 * `Headers` counterpart of `getWorktreeHeaders`, for base queries using `prepareHeaders`. Leaves
 * the headers untouched when no worktree is selected.
 */
export const setWorktreeHeader = (headers: Headers) => {
  match(getWorktreeName())
    .with(Pattern.string.minLength(1), (worktreeName) => {
      headers.set(WORKTREE_HEADER, worktreeName);
    })
    .otherwise(() => undefined);

  return headers;
};
